import { Inject } from '@odinjs/odin';

import { CONFIRMATION_FIELD_VALID, confirmationFieldValidator, Endpoint, FOUNDATION_ROUTES, passwordValidator, PWD_VALIDATOR, Retorno, Route, SENHA_NOVA_DIFERENTE_ATUAL, senhaNovaDiferenteDaAtual, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { ButtonAPI, FieldAPI, FormAPI, ModalAPI, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnChange, OnClick, OnClose, OnMount, OnSubmit, OnValidate } from '@philips-emr/tws-core/lib/client';
import { SubmitEvent, ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService, msg } from '@philips-emr/tws-core/lib/services';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';

import BaseController from '../BaseController';

interface Data {
  username: string,
  response: string,
}

@Controller({ fragment: 'alterar-senha' })
export default class AlterarSenhaController extends BaseController {
  @Inject('form-alt-senha')
  private formAltSenha: FormAPI;

  @Inject('field-nova-senha')
  private fieldNovaSenha: FieldAPI;

  @Inject('field-nova-senha-confirm')
  private fieldNovaSenhaConfirm: FieldAPI;

  @Inject('toast-notification')
  private toast: ToastNotificationAPI;

  @Inject('button-alt-senha')
  private buttonAltSenha: ButtonAPI;

  @Inject('panel-loader')
  private loader: PanelAPI;

  @Inject('panel-modal')
  private modal: PanelAPI;

  @Inject('modal-senhas')
  private modalSenhas: ModalAPI;

  @Inject('panel-success')
  private panelSuccess: ModalAPI;

  @OnMount('panel-modal')
  onMountModal(): void {
    if (StipulatorContext.getCurrentContract()) {
      this.modalSenhas.setTitle(msg('stipulator.alterar-senha'));
    }
  }

  @OnMount({ target: 'form-alt-senha' })
  onMountModalAltSenha(): void {
    this.fieldNovaSenha.addLocalValidator(PWD_VALIDATOR, passwordValidator);

    this.fieldNovaSenhaConfirm.addLocalValidator(CONFIRMATION_FIELD_VALID, (value) => {
      const confirmationValue = this.formAltSenha.getRecord()['novaSenha'] || '';
      return confirmationFieldValidator(value, confirmationValue);
    });

    this.fieldNovaSenha.addLocalValidator(SENHA_NOVA_DIFERENTE_ATUAL, (value) => {
      const senhaAtual = this.formAltSenha.getRecord()['senhaAtual'] || '';
      return senhaNovaDiferenteDaAtual(value, senhaAtual);
    });
  }

  @OnChange({ target: 'form-alt-senha' })
  onChangeForm(): void {
    this.toast.setVisible(false);
  }

  @OnValidate({ target: 'form-alt-senha' })
  onValidateForm(event: ValidateEvent): void {
    const { valid } = event;

    this.buttonAltSenha.setEnabled(valid);
  }

  @OnSubmit({ target: 'form-alt-senha' })
  onSubmitFormAltSenha(event: SubmitEvent): void {
    const { record } = event;

    if (this.formAltSenha.isValid()) {
      this.buttonAltSenha.setEnabled(false);
      this.loader.setVisible(true);

      void HttpService.post<Retorno<string>>(Endpoint.POST.ALTERAR_SENHA, {}, { body: record })
        .then(() => {
          this.loader.setVisible(false);
          this.toast.setLevel(ToastLevel.SUCCESS);
          this.toast.setVisible(true);
          this.toast.setMessage(`${MessageService.msg('stipulator.sucesso-alteracao')} ${MessageService.msg('stipulator.aguarde-redirecionando')}`);
          this.modal.setVisible(false);

          if (StipulatorContext.getCurrentContract()) {
            this.historyService.push(Route.MEUS_DADOS);
            ToastServiceStipulator.successBubble(msg('stipulator.sucesso-alteracao'));
          } else {
            this.historyService.push(FOUNDATION_ROUTES.HOME);
          }

        })
        .catch(resp => {
          const { body: retorno } = resp;
          if (retorno) {
            this.loader.setVisible(false);
            this.toast.setVisible(true);
            this.toast.setMessage(retorno.response);
            this.formAltSenha.setEditing(true);
          }
        });
    }
  }

  @OnClick({ target: ['button-alt-senha'] })
  onClickAltSenha(): void {
    const { username } = this.historyService.getCurrentRouteParams() as unknown as Data;
    this.alterarSenha(username);
  }
  @OnClick({ target: ['button-ok'] })
  onClickOk(): void {
    this.historyService.push(FOUNDATION_ROUTES.HOME);
  }

  @OnClose({ target: 'modal-success' })
  onCloseSuccess(): void {
    this.historyService.push(FOUNDATION_ROUTES.HOME);
  }

  @OnClose({ target: 'modal-senhas' })
  onCloseModal(): void {
    this.modal.setVisible(false);
    this.historyService.push(Route.MEUS_DADOS);
  }

  alterarSenha(username: string): void {

    if (username) {
      this.renovarSenha();
    } else {
      this.formAltSenha.submit();
    }
  }

  renovarSenha(): void {
    const body = this.formAltSenha.getRecord();
    const { username } = this.historyService.getCurrentRouteParams();
    HttpService.post(Endpoint.POST.RENOVAR_SENHA_BY_USERNAME, { username }, { body })
      .then(() => {
        this.handleSuccess();
      }).catch(resp => {
        this.handleFailure(resp);
      });
  }

  handleSuccess(): void {
    this.panelSuccess.setVisible(true);
    this.modal.setVisible(false);
  }

  handleFailure(resp: RequestResponse<unknown>): void {
    this.formAltSenha.setEditing(true);
    this.loader.setVisible(false);
    const { response } = resp.body as Data;
    this.toast.setLevel(ToastLevel.WARNING);
    this.toast.setVisible(true);
    this.toast.setMessage(response);
  }

}
